import styled from 'styled-components'
import { mediaQ, fontSizeResponsive } from '../../theme/mixins'
import trashicon from '../../../assets/DietModuleAssets/trashicon.png'

export const ScreenContainer = styled.div`
  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'unset')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'unset')};
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'unset'};
  flex-wrap: wrap;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : 'unset')};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginTop : 'unset')};
  padding: ${(props) => (props.padding ? props.padding : 'unset')};
  box-sizing: border-box;
`

export const MainHeader = styled.div`
  width: 100%;
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: normal;
  text-align: center;
  color: #fe0d9f;
  margin-top: 3vh;
  ${fontSizeResponsive(62)}
`

export const MainSubHeader = styled.div`
  width: 100%;
  font-family: 'Asap Condensed';
  font-size: 31px;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.16;
  letter-spacing: normal;
  text-align: center;
  color: #212121;
  margin-top: 20px;
  ${fontSizeResponsive(31)}
  text-transform: uppercase;
`

export const MainContentContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) => (props.justify ? props.justify : 'unset')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'unset')};
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'unset'};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : 'unset')};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : 'unset'};
  padding: ${(props) => (props.padding ? props.padding : 'unset')};
  box-sizing: border-box;
  max-width: 100%;
  width: 100%;
  position: relative;

  ${mediaQ('mobileAll', 'margin-bottom:8vh;')}
`

export const VerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: #ffdbf1;
  margin: 0 20px;
  display: ${(props) => (props.display ? props.display : 'none')};
`

export const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ffdbf1;
  margin: 20px 0;
`

export const TextHeaderRow = styled.div`
  font-family: 'Nunito';
  width: fit-content;
  color: white;
  width: 70%;
  display: block;
  ${fontSizeResponsive(20)};
  font-weight: 700;
  font-stretch: condensed;
  font-style: normal;
  line-height: 0.96;
  letter-spacing: normal;

  text-align: ${(props) => (props.align ? props.align : 'center ')};

  ${mediaQ('oldIpads', 'padding:5px;')}
  ${mediaQ('ipad9', 'padding:5px;')}
  ${mediaQ('ipad10', 'padding:5px;')}
  ${mediaQ('ipad12', 'padding:5px;')}


  @media only screen and (max-width: 600px) {
    ${fontSizeResponsive(24)};
  }

  &.daily-balance-header {
    margin-top: 30%;
  }
`

export const AltTextHeaderRow = styled.div`
  font-family: 'Open Sans';
  ${fontSizeResponsive(24)};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.08;
  letter-spacing: normal;
  color: #fe0d9f;
  text-align: center;
`

export const PostscriptTextRow = styled.div`
  opacity: 0.5;
  font-family: 'Open Sans';
  font-size: ${(props) => (props.fontSize ? props.fontSize + 'px' : 'inherit')};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.13;
  letter-spacing: normal;
  text-align: center;
  color: #212121;
`

export const MealIngredientName = styled.span`
  font-family: 'Nunito';
  ${fontSizeResponsive(21)};
  font-weight: bold;

  font-stretch: condensed;
  font-style: normal;
  color: white;
  width: 60%;
  /* line-height: 1.83; */
  letter-spacing: normal;
  text-align: left;
  /* color: #212121; */
  display: flex;
  align-items: center;
  /* text-transform: uppercase; */

  &.diet-main-page {
    ${fontSizeResponsive(16)};
    width: 51%;
    @media only screen and (max-width: 600px) {
      ${fontSizeResponsive(20)};
    }
  }
`

export const MealIngredientKcalValue = styled.span`
  font-family: 'Nunito';
  ${fontSizeResponsive(16)};
  opacity: 0.9;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  color: white;
  position: relative;
  left: -10%;
  /* color: #212121; */
  letter-spacing: normal;
  text-align: left;
  display: flex;
  align-items: center;
  white-space: nowrap;

  @media only screen and (max-width: 600px) {
    ${fontSizeResponsive(20)};
  }
`

export const MealIngredientWeightValue = styled.span`
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(18)};
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.94;
  letter-spacing: normal;
  text-align: left;
  color: #fe0d9f;

  @media only screen and (max-width: 600px) {
    ${fontSizeResponsive(22)};
  }
`

export const MealIngredientRow = styled.div`
  font-family: 'Nunito';
  width: ${(props) => (props.width ? props.width : '100%')};
  display: flex;
  align-items: baseline;
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'unset'};
  justify-content: ${(props) => (props.justify ? props.justify : 'unset')};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  position: relative;
  color: white;
  opacity: 0.8;

  /* &:hover {
    color: blueviolet;
  } */
`
export const MealsMainHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(27)};
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 0.96;
  letter-spacing: normal;
  text-align: center;
  color: #9e0dfe;
  text-transform: uppercase;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
`

export const BigHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: 'Nunito';
  ${fontSizeResponsive(37)};
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 0.65;
  letter-spacing: normal;
  text-align: center;
  color: #fe0d9f;
  text-transform: uppercase;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
`

export const NutritionalValuesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`

export const NutritionalValue = styled.div`
  display: flex;
  flex-direction: column;
`

export const Value = styled.span`
  width: 100%;
  display: inline-block;
  text-align: center;
  font-family: 'Nunito';
  font-size: 1.3rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  /* line-height: 1.56; */
  letter-spacing: normal;
  color: #a1ff68;

  @media only screen and (max-width: 600px) {
    ${fontSizeResponsive(28)}
  }
`
export const Name = styled.span`
  width: 100%;
  display: inline-block;
  text-align: center;
  font-family: 'Nunito';
  ${fontSizeResponsive(24)};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.78;
  letter-spacing: normal;
  color: white;

  @media only screen and (max-width: 600px) {
    ${fontSizeResponsive(24)}
  }
`
export const DietStandardButton = styled.button`
  font-family: 'Asap Condensed';
  font-size: ${(props) =>
    props.fSize ? fontSizeResponsive(props.fSize) : fontSizeResponsive(20)};
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.35;
  letter-spacing: normal;
  text-align: center;
  color: ${(props) => (props.color ? props.color : 'black')};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : 'unset'};
  padding: ${(props) => (props.padding ? props.padding : '10px 20px')};
  border: none;
  border-radius: 4px;
  box-shadow: 0 0px 2.2px rgba(0, 0, 0, 0.02),
    0 0.1px 5.3px rgba(0, 0, 0, 0.028), 0 0.1px 10px rgba(0, 0, 0, 0.035),
    0 0.2px 17.9px rgba(0, 0, 0, 0.042), 0 0.4px 33.4px rgba(0, 0, 0, 0.05),
    0 1px 80px rgba(0, 0, 0, 0.07);
  text-transform: uppercase;
  margin: ${(props) => (props.margin ? props.margin : '0 5px')};
  width: ${(props) => (props.width ? props.width : 'unset')};

  transition: ease-in-out 0.3s all;

  &.checked {
    background-color: #9e0dfe;
  }

  &:hover {
    transform: scale(1.1);
  }
`

export const DietStandardRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${(props) => (props.justify ? props.justify : 'unset')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'unset')};
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'unset'};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : 'unset')};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginTop : 'unset')};
  padding: ${(props) => (props.padding ? props.padding : 'unset')};
  box-sizing: border-box;
  /* max-width: 100%; */
  width: ${(props) => (props.width ? props.width : '100%')};
`

export const TextBold = styled.div`
  font-family: 'Asap Condensed';
  font-size: ${(props) =>
    props.fSize ? fontSizeResponsive(props.fSize) : fontSizeResponsive(16)};
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: center;
  color: #212121;
  width: 100%;
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')}
    ${mediaQ('mobileAll', 'padding: 0 5%')};
`

export const TextNormal = styled.span`
  font-family: 'Asap Condensed';
  font-size: ${fontSizeResponsive(16)};
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: left;
  color: #212121;

  ${mediaQ('mobileAll', 'padding: 0 5%')}
`

export const TrashButton = styled.button`
  right: 10vw;
  top: 20vh;
  border: none;
  position: absolute;
  width: 25px;
  height: 30px;
  background: url(${trashicon});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  ${mediaQ('mobileAll', 'width:11px; height: 16px;top: 26vh;')}
`

export const ChangeDietButton = styled.button`
  border: none;
  width: 25px;
  height: 30px;

  background-color: red;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
`

export const MainDietButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`
export const NoMeals = styled.div`
  position: absolute;
  width: 94%;
  text-align: center;
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.35;
  background-color: white;

  ${mediaQ('mobileAll', 'width:100%; margin-top:10px;')}
`
